/**
 * Skeleton definitions for built-in templates.
 *
 * Contains the structural properties that don't change when tweaking
 * a template in the UI: zone types, labels, data bindings, background
 * type, and magazine defaults. The user-tweakable properties (bounds,
 * styles, transforms, canvas size, bg blur/brightness) live in the
 * companion JSON files in builtin/ which match the project save format.
 *
 * To update a template: tweak it in the UI, download the project JSON,
 * and replace the corresponding file in src/templates/builtin/.
 */

export const TEMPLATE_SKELETONS = {
  'wide-3d-angled': {
    name: 'Wide — 3D Angled',
    background: {
      type: 'image',
      processing: { blur: 15, brightness: -0.3, overlay: 'rgba(230,120,30,0.4)' },
      cropRegion: { x: 0, y: 0.2, width: 1, height: 0.5 },
    },
    magazine: { binding: 'saddle', pages: 60 },
    zones: {
      cover:       { type: 'magazineCover',  label: 'Magazine Cover',    binding: 'coverImage' },
      spread3:     { type: 'magazineSpread', label: 'Article Spread 3',  binding: 'spreadPages[2]' },
      spread2:     { type: 'magazineSpread', label: 'Article Spread 2',  binding: 'spreadPages[1]' },
      spread1:     { type: 'magazineSpread', label: 'Article Spread 1',  binding: 'spreadPages[0]' },
      title:       { type: 'text',           label: 'Magazine Title',    binding: 'editionTitle' },
      subtitle:    { type: 'text',           label: 'Subtitle',          binding: 'editionSubtitle' },
      editionBadge:{ type: 'badge',          label: 'Edition Badge',     binding: 'editionBadgeText' },
      ctaButton:   { type: 'cta',            label: 'Call to Action',    binding: 'ctaText' },
    },
  },

  'wide-forest-blur': {
    name: 'Wide — Forest Blur',
    background: {
      type: 'image',
      processing: { blur: 15, brightness: -0.3, overlay: 'rgba(0,0,0,0.25)' },
      cropRegion: { x: 0, y: 0.1, width: 1, height: 0.5 },
    },
    magazine: { binding: 'saddle', pages: 60 },
    zones: {
      title:       { type: 'text',           label: 'Magazine Title',    binding: 'editionTitle' },
      subtitle:    { type: 'text',           label: 'Subtitle',          binding: 'editionSubtitle' },
      cover:       { type: 'magazineCover',  label: 'Magazine Cover',    binding: 'coverImage' },
      spread1:     { type: 'magazineSpread', label: 'Article Spread 1',  binding: 'spreadPages[0]' },
      spread2:     { type: 'magazineSpread', label: 'Article Spread 2',  binding: 'spreadPages[1]' },
      spread3:     { type: 'magazineSpread', label: 'Article Spread 3',  binding: 'spreadPages[2]' },
      editionBadge:{ type: 'badge',          label: 'Edition Badge',     binding: 'editionBadgeText' },
      ctaButton:   { type: 'cta',            label: 'Call to Action',    binding: 'ctaText' },
    },
  },

  'rect-forest-blur': {
    name: 'Rectangle — Forest Blur',
    background: {
      type: 'image',
      processing: { blur: 15, brightness: -0.3, overlay: 'rgba(0,0,0,0.25)' },
    },
    magazine: { binding: 'saddle', pages: 60 },
    zones: {
      title:       { type: 'text',           label: 'Magazine Title',    binding: 'editionTitle' },
      subtitle:    { type: 'text',           label: 'Subtitle',          binding: 'editionSubtitle' },
      cover:       { type: 'magazineCover',  label: 'Magazine Cover',    binding: 'coverImage' },
      spread1:     { type: 'magazineSpread', label: 'Article Spread 1',  binding: 'spreadPages[0]' },
      spread2:     { type: 'magazineSpread', label: 'Article Spread 2',  binding: 'spreadPages[1]' },
      spread3:     { type: 'magazineSpread', label: 'Article Spread 3',  binding: 'spreadPages[2]' },
      editionBadge:{ type: 'badge',          label: 'Edition Badge',     binding: 'editionBadgeText' },
      ctaButton:   { type: 'cta',            label: 'Call to Action',    binding: 'ctaText' },
    },
  },
};
